const formatToBRL = (value: number) => {
    value = value || 0;
    return value.toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
    });
};

export default formatToBRL;
